import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import { ParticipantService } from '../../services/wealthlane-customer-services';

const useGetCustomerParticipantList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  enabled?: boolean
): UseQueryResult<any, unknown> => {
  const {
    // employeeStatusId,
    approvalStatusIds,
    employeeType,
    accountStatus,
    emailStatus,
    brokerAccountStatusIds,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    _force,
  } = tableInfo;

  const customerParticipantList = useQuery(
    [
      'getCustomerParticipantList',
      approvalStatusIds,
      employeeType,
      accountStatus,
      emailStatus,
      brokerAccountStatusIds,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        ParticipantService.getApiCustomerApiAppParticipantParticipantsList(
          approvalStatusIds,
          employeeType,
          accountStatus,
          emailStatus,
          brokerAccountStatusIds,
          filter,
          sorting,
          skipCount,
          maxResultCount
        ).then((res: any) => ({
          ...res,
          items: res.items.map((participants: any) => ({
            ...participants,
            status: participants?.approvalStatus,
          })),
        }))
      );
    },
    {
      enabled: enabled !== false,
    }
  );

  return customerParticipantList;
};

export default useGetCustomerParticipantList;
